<div class="expandable-panel" [class.expanded]="expanded" [class.covers-window]="expanded && !area"
     [ngStyle]="expanded && area ? {top: area.top + 'px', left: area.left + 'px', width: area.width + 'px', height: area.height + 'px'} : null">
  <div class="expandable-content">
    <ng-content></ng-content>
  </div>
</div>
